import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CsIconModule } from '@components/icon';
import { EventLoggerService } from '@services/event-logger-service';

@Component({
  selector: 'more-for-you',
  imports: [CsIconModule],
  templateUrl: './more-for-you.component.html',
})
export class MoreForYouComponent {
  takePhotoImageUrl: string = 'https://cdn.cureskin.com/app/img/rebranded_take_photo_banner.png';

  router = inject(Router);
  private readonly eventLogger = inject(EventLoggerService);
  constructor() {}

  navigateToTakePhotoAnalysis(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'more_for_you_take_photo_analysis' }));
    this.router.navigate(['/user/instantCheckup']);
  }

  navigateToRefer(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'more_for_you_refer' }));
    this.router.navigate(['/user/refer']);
  }

  handleReportReactionClick(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'more_for_you_report_reaction' }));
    this.router.navigate(['/support']);
  }
}
